import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./TagBubble.module.scss";

type Props = {
  index: number;
  name: string;

  removeHandler?: (i: number) => void;
};

const TagBubble: React.FC<Props> = ({ index, name, removeHandler }) => {
  return (
    <div className={styles["c-tag-bubble__item"]}>
      {name}
      {removeHandler ? (
        <button type="button" onClick={() => removeHandler(index)}>
          <FontAwesomeIcon icon={["fas", "times-circle"]} />
        </button>
      ) : null}
    </div>
  );
};

export default TagBubble;
